module.exports = __webpack_public_path__ + "media/images/sp/specials/common/present_import_dress-2e22836417aa8dd6002db51634201a4a.png";